import { render } from "./HonoraryInvitations00.vue?vue&type=template&id=2e0a506b&scoped=true"
const script = {}

import "./HonoraryInvitations00.vue?vue&type=style&index=0&id=2e0a506b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0a506b"]])

export default __exports__